import React, { useState } from "react";
import { useField } from "../Form/useField";
import { Dropzone } from "../../components";

type Props = {
  isDisabled?: boolean;
  allowMultipleFiles?: boolean;
  id: string;
  onFileUpload: (files: File[]) => Promise<any>;
  onFileRemove: (file: File) => Promise<any>;
  handleError: (error: Error) => void;
  className?: string;
  name: string;
  required?: boolean;
  maxFileCount: number;
  hint: string;
  maxTotalByteSize: number;
  acceptedFileTypes: string[];
  defaultValue?: File[];
};

const FileUploadField: React.FC<Props> = ({
  id,
  allowMultipleFiles,
  className,
  handleError,
  name,
  hint,
  required,
  maxFileCount,
  maxTotalByteSize,
  acceptedFileTypes,
  onFileUpload,
  onFileRemove,
  defaultValue = []
}) => {
  const { value, onChange } = useField({ name, required, defaultValue });

  const [uploadLoading, setUploadLoading] = useState(false);

  return (
    <Dropzone
      acceptedFileTypes={acceptedFileTypes}
      allowMultipleFiles={allowMultipleFiles}
      className={className}
      files={value}
      hint={hint}
      loading={uploadLoading}
      id={id}
      maxFileCount={maxFileCount}
      maxTotalByteSize={maxTotalByteSize}
      onNewFiles={async (files: File[]) => {
        setUploadLoading(true);
        try {
          await onFileUpload(files);
          setUploadLoading(false);
          onChange([...value, ...files]);
        } catch (error) {
          handleError(error);
          setUploadLoading(false);
        }
      }}
      onRemoveFile={async (file: File, index: number) => {
        try {
          await onFileRemove(file);
          const attachments = [...value];
          attachments.splice(index, 1);
          onChange(attachments);
        } catch (error) {
          handleError(error);
        }
      }}
    />
  );
};

export default FileUploadField;
